// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-info-__slug-index-wrapper-beoqj{display:grid;grid-gap:24px}.pages-info-__slug-index-pageWrapper-bfyqf{padding-bottom:48px}.pages-info-__slug-index-pageWrapper-bfyqf.pages-info-__slug-index-mobile-xmzoi{padding-top:48px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "pages-info-__slug-index-wrapper-beoqj",
	"pageWrapper": "pages-info-__slug-index-pageWrapper-bfyqf",
	"mobile": "pages-info-__slug-index-mobile-xmzoi"
};
module.exports = ___CSS_LOADER_EXPORT___;
